import { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { IconButton, Typography, MenuItem, Menu } from "@mui/material";

function UserAvatar(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [username, setUsername] = useState("-");

  const getUserInfo = async () => {
    if (props.user == null) {
      return null;
    }
    setUsername(props.user[5].Value);
  };

  useEffect(() => {
    getUserInfo();
    // eslint-disable-next-line
  }, [props.user]);
  const signOutOfCognitoAccount = async () => {
    try {
      await Auth.signOut();
      let newUser = {
        user: null,
        identity: {
          dob: null,
          idType: null,
          idNumber: null,
        },
      };
      props.setUser(newUser);
      props.setActiveStep(0);
    } catch (error) {
      console.error("error signing out: ", error);
    }
  };
  return (
    <>
      <IconButton
        sx={{
          border: "1px solid lightgray",
          width: "40px",
          height: "40px",
        }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {/* <AccountCircleIcon /> */}
        {username[0].toUpperCase()}
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <Typography>Welcome, {username}.</Typography>
        </MenuItem>
        <MenuItem onClick={(handleClose, signOutOfCognitoAccount)}>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}

export default UserAvatar;
